import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

// Compress an image File/Blob to a JPEG via canvas (longest edge ≤ maxEdge),
// targeting a small upload (~tens of KB). Returns a Blob.
export function compressImage(file, maxEdge = 1280, quality = 0.7) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, maxEdge / Math.max(img.width, img.height));
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('compress failed'))), 'image/jpeg', quality);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('could not read image')); };
    img.src = url;
  });
}

// Upload a proof image/signature blob under the tenant-scoped path the Storage
// rules require: tenants/{tenantId}/leads/{leadId}/{ts}-{kind}.{ext}. Returns URL.
export async function uploadProof(tenantId, leadId, blob, kind = 'photo') {
  if (!tenantId || !leadId || !blob) throw new Error('uploadProof: missing tenantId/leadId/blob');
  const ext = blob.type === 'image/png' ? 'png' : 'jpg';
  const path = `tenants/${tenantId}/leads/${leadId}/${Date.now()}-${kind}.${ext}`;
  const r = ref(storage, path);
  await uploadBytes(r, blob, { contentType: blob.type });
  return getDownloadURL(r);
}
